"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureCollectionDifference = void 0;
const turf_1 = require("@turf/turf");
const geojson_converters_1 = require("../geojson-converters");
/**
 *  Extracts features from the inputPolys that fall outside features in the overlayPolys. Only properties from the inputPolys are retained.
 *
 * @param inputPolys the main FeatureCollection of features with properties to be kept
 * @param overlayPolys the secondary FeatureCollection to subtract from the input
 * @returns FeatureCollection. input - overlay
 */
function featureCollectionDifference(inputPolys, overlayPolys) {
    const inputSingles = (0, geojson_converters_1.flattenMultiFeatureCollection)(inputPolys);
    const overlayDissolved = (0, geojson_converters_1.flattenFeatureCollection)(overlayPolys);
    const diff = (0, turf_1.featureCollection)(inputSingles.features.map((f) => {
        var _a;
        return ({
            ...f,
            geometry: (_a = (0, turf_1.difference)(f, overlayDissolved)) === null || _a === void 0 ? void 0 : _a.geometry,
        });
    }));
    const validGeometry = diff.features.filter((f) => f.geometry !== undefined);
    return (0, turf_1.featureCollection)(validGeometry);
}
exports.featureCollectionDifference = featureCollectionDifference;
